import { action } from "./index";

export const ADD_BET = "COUPON/ADD_BET";
export const addBet = (marketId, betId) => action(ADD_BET, { marketId, betId });

export const REMOVE_BET = "COUPON/REMOVE_BET";
export const removeBet = (marketId, betId) => action(REMOVE_BET, { marketId, betId });

export const REMOVE_ALL = "COUPON/REMOVE_ALL";
export const removeAll = () => action(REMOVE_ALL);

export const OPEN = "COUPON/OPEN";
export const openCoupon = () => action(OPEN);

export const CLOSE = "COUPON/CLOSE";
export const closeCoupon = () => action(CLOSE);

export const SET_COUPON_STATE = "COUPON/SET_COUPON_STATE";
export const setCouponState = (couponState) => action(SET_COUPON_STATE, { couponState });

export const SET_ERROS = "COUPON/SET_ERROS";
export const setErrors = (errors) => action(SET_ERROS, { errors });


// WEBPACK FOOTER //
// ./app/actions/couponActions.js